import { Component, OnInit } from '@angular/core';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { BaseEntity, BaseState } from '@base/entities/BaseEntities';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { SysGlobals } from '@core/framework/sysglobals';
import { LoginService } from '@m4u-angular/core/framework/login.service';
import { SidebarService } from '@m4u-angular/core/framework/sidebar.service';


@Component({
    providers: ServiceBagServices,
    selector: 'm4u-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss']
})
export class LogoutComponent extends BasePageComponent<BaseEntity, BaseState> implements OnInit {

    constructor(A: ServiceBagService,
        private loginService: LoginService,
        private sidebarService: SidebarService) {
        super(A, 'LogoutComponent', BaseEntity, BaseState);
    }

    override ngOnInit() {
        this.loginService.DoLogout(() => {
            this.sidebarService.ClearSidebars();
            setTimeout(() => { this.Navigate(['/system/login'], { Language: SysGlobals.Language }); }, 4000);
        });  
    }
}
